import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'

import {getLogSummary} from '../../../apis/backendlogs/getLogsList'

const useQueryLotLog = (server_id: string, created_at: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.logSummary.getLogSummary(),
        queryFn: async () => {
            const {data} = await getLogSummary(server_id, created_at)
            return data
        },
    })

    return {data, refetch}
}

export default useQueryLotLog
